 export const map_messages = (source, status, dateFrom, dateTo, t, business, adAccount, fbPage, instaPage, flow, index) => {
    if(source === "dates") {
        if(flow.length === 0) {
            return {
                section: (t("Dates")),
                title : (t("Dates are set successfully")),
                text : dateFrom + (t(" to ")) + dateTo,
                main: (t("Go to report")), 
                red: "",
                img :"https://genius1071.friktoriaservers.net/doitforme/morning/app/global/Success.svg"
            }
        }
        else if (flow[0] === "paid") {
            return {
                section: (t("Dates")),
                title : (t("Dates are set successfully")),
                text : dateFrom + (t(" to ")) + dateTo,
                main: (t("Integrate Meta Ad account")), 
                red : (t("Do not integrate Meta Ad account")), 
                img :"https://genius1071.friktoriaservers.net/doitforme/morning/app/global/Success.svg"
            };
        }
        else if(flow[0] === "facebook") {
            return {
                section: (t("Dates")),
                title : (t("Dates are set successfully")),
                text : dateFrom + (t(" to ")) + dateTo,
                main: (t("Integrate Facebook page")), 
                red : (t("Do not integrate Facebook page")), 
                img :"https://genius1071.friktoriaservers.net/doitforme/morning/app/global/Success.svg"
            };
        }
        else if(flow[0] === "instagram") {
            return {
                section: (t("Dates")),
                title : (t("Dates are set successfully")),
                text : dateFrom + (t(" to ")) + dateTo,
                main: (t("Integrate Instagram Page")), 
                red : (t("Do not integrate Instagram page")),
                img :"https://genius1071.friktoriaservers.net/doitforme/morning/app/global/Success.svg"
            };
        }
    }
    else if(source === "paid") {
        if (flow[index] === "paid" && status === true) {
            return {
                section: (t("Business Manager and Ad Account")),
                title : (t("Business Manager and Ad Account set successfully")),
                text : business + (t(" and ")) + adAccount,
                main: (t("Integrate Meta Ad account")), 
                red : (t("Do not integrate Meta Ad account")), 
                img :"https://genius1071.friktoriaservers.net/doitforme/morning/app/global/Success.svg"
            };
        }
        else if(flow[index] === "paid" && status === false) {
            return {
                section: (t("Business Manager and Ad Account")),
                title : (t("Business Manager and Ad Account not set successfully")),
                text : (t("I changed my mind")),
                main: (t("Integrate Meta Ad account")), 
                red : (t("Do not integrate Meta Ad account")), 
                img :"https://genius1071.friktoriaservers.net/doitforme/morning/app/global/Fail.svg"
            };
        }
        else if(flow[index] === "facebook" && status === true) {
            return {
                section: (t("Business Manager and Ad Account")),
                title : (t("Business Manager and Ad Account set successfully")),
                text : business + (t(" and ")) + adAccount,
                main: (t("Integrate Facebook page")), 
                red : (t("Do not integrate Facebook page")), 
                img :"https://genius1071.friktoriaservers.net/doitforme/morning/app/global/Success.svg"
            };
        }
        else if(flow[index] === "facebook" && status === false) {
            return {
                section: (t("Business Manager and Ad Account")),
                title : (t("Business Manager and Ad Account not set successfully")),
                text : (t("I changed my mind")),
                main: (t("Integrate Facebook page")), 
                red : (t("Do not integrate Facebook page")), 
                img :"https://genius1071.friktoriaservers.net/doitforme/morning/app/global/Fail.svg"
            };
        }
        else if(flow[index] === "instagram" && status === true) {
            return {
                section: (t("Business Manager and Ad Account")),
                title : (t("Business Manager and Ad Account set successfully")),
                text : business + (t(" and ")) + adAccount,
                main: (t("Integrate Instagram Page")), 
                red : (t("Do not integrate Instagram page")),
                img :"https://genius1071.friktoriaservers.net/doitforme/morning/app/global/Success.svg"
            };
        }
        else if(flow[index] === "instagram" && status === false) {
            return {
                section: (t("Business Manager and Ad Account")),
                title : (t("Business Manager and Ad Account not set successfully")),
                text : (t("I changed my mind")),
                main: (t("Integrate Instagram Page")), 
                red : (t("Do not integrate Instagram page")),
                img :"https://genius1071.friktoriaservers.net/doitforme/morning/app/global/Fail.svg"
            };
        }
        else if (!flow[index] && status === true) {
            return {
                section: (t("Business Manager and Ad Account")),
                title : (t("Business Manager and Ad Account set successfully")),
                text : instaPage,
                main: (t("Go to report")), 
                red: "",
                img :"https://genius1071.friktoriaservers.net/doitforme/morning/app/global/Success.svg"
            };
        }
        else if (!flow[index] && status === false) {
            return {
                section: (t("Business Manager and Ad Account")),
                title : (t("Business Manager and Ad Account set successfully")),
                text : (t("I changed my mind")),
                main: (t("Go to report")), 
                red: "",
                img :"https://genius1071.friktoriaservers.net/doitforme/morning/app/global/Fail.svg"
            };
        }
    }
    else if(source === "facebook") {
        if (flow[index] === "paid" && status === true) {
            return {
                section: (t("Facebook page")),
                title : (t("Facebook page set successfully")),
                text : fbPage,
                main: (t("Integrate Meta Ad account")), 
                red : (t("Do not integrate Meta Ad account")), 
                img :"https://genius1071.friktoriaservers.net/doitforme/morning/app/global/Success.svg"
            };
        }
        else if (flow[index] === "paid" && status === false) {
            return {
                section: (t("Facebook page")),
                title : (t("Facebook page not set successfully")),
                text : (t("I changed my mind")),
                main: (t("Integrate Meta Ad account")), 
                red : (t("Do not integrate Meta Ad account")), 
                img :"https://genius1071.friktoriaservers.net/doitforme/morning/app/global/Fail.svg"
            };
        }
        else if(flow[index] === "facebook" && status === true) {
            return {
                section: (t("Facebook page")),
                title : (t("Facebook page set successfully")),
                text : fbPage,
                main: (t("Integrate Facebook page")), 
                red : (t("Do not integrate Facebook page")), 
                img :"https://genius1071.friktoriaservers.net/doitforme/morning/app/global/Success.svg"
            };
        }
        else if(flow[index] === "facebook" && status === false) {
            return {
                section: (t("Facebook page")),
                title : (t("Facebook page not set successfully")),
                text : (t("I changed my mind")),
                main: (t("Integrate Facebook page")), 
                red : (t("Do not integrate Facebook page")), 
                img :"https://genius1071.friktoriaservers.net/doitforme/morning/app/global/Fail.svg"
            };
        }
        else if(flow[index] === "instagram" && status === true) {
            return {
                section: (t("Facebook page")),
                title : (t("Facebook page set successfully")),
                text : fbPage,
                main: (t("Integrate Instagram Page")), 
                red : (t("Do not integrate Instagram page")),
                img :"https://genius1071.friktoriaservers.net/doitforme/morning/app/global/Success.svg"
            };
        }
        else if(flow[index] === "instagram" && status === false) {
            return {
                section: (t("Facebook page")),
                title : (t("Facebook page not set successfully")),
                text : (t("I changed my mind")),
                main: (t("Integrate Instagram Page")), 
                red : (t("Do not integrate Instagram page")),
                img :"https://genius1071.friktoriaservers.net/doitforme/morning/app/global/Fail.svg"
            };
        }
        else if(!flow[index] && status === true) {
            return {
                section: (t("Facebook page")),
                title : (t("Facebook page set successfully")),
                text : instaPage,
                main: (t("Go to report")), 
                red: "",
                img :"https://genius1071.friktoriaservers.net/doitforme/morning/app/global/Success.svg"
            };
        }
        else if(!flow[index] && status === false) {
            return {
                section: (t("Facebook page")),
                title : (t("Facebook page not set successfully")),
                text : (t("I changed my mind")),
                main: (t("Go to report")), 
                red: "",
                img :"https://genius1071.friktoriaservers.net/doitforme/morning/app/global/Fail.svg"
            };
        }   
    }
    else if(source === "instagram") {
        if (flow[index] === "paid" && status === true) {
            return {
                section: (t("Instagram page")),
                title : (t("Instagram page set successfully")),
                text : instaPage,
                main: (t("Integrate Meta Ad account")), 
                red : (t("Do not integrate Meta Ad account")), 
                img :"https://genius1071.friktoriaservers.net/doitforme/morning/app/global/Success.svg"
            };
        }
        else if (flow[index] === "paid" && status === false) {
            return {
                section: (t("Instagram page")),
                title : (t("Instagram page not set successfully")),
                text : (t("I changed my mind")),
                main: (t("Integrate Meta Ad account")), 
                red : (t("Do not integrate Meta Ad account")), 
                img :"https://genius1071.friktoriaservers.net/doitforme/morning/app/global/Fail.svg"
            };
        }
        else if(flow[index] === "facebook" && status === true) {
            return {
                section: (t("Instagram page")),
                title : (t("Instagram page set successfully")),
                text : instaPage,
                main: (t("Integrate Facebook page")), 
                red : (t("Do not integrate Facebook page")), 
                img :"https://genius1071.friktoriaservers.net/doitforme/morning/app/global/Success.svg"
            };
        }
        else if(flow[index] === "facebook" && status === false) {
            return {
                section: (t("Instagram page")),
                title : (t("Instagram page not set successfully")),
                text : (t("I changed my mind")),
                main: (t("Integrate Facebook page")), 
                red : (t("Do not integrate Facebook page")), 
                img :"https://genius1071.friktoriaservers.net/doitforme/morning/app/global/Fail.svg"
            };
        }
        else if(flow[index] === "instagram" && status === true) {
            return {
                section: (t("Instagram page")),
                title : (t("Instagram page set successfully")),
                text : instaPage,
                main: (t("Integrate Instagram Page")), 
                red : (t("Do not integrate Instagram page")),
                img :"https://genius1071.friktoriaservers.net/doitforme/morning/app/global/Success.svg"
            };
        }      
        else if(flow[index] === "instagram" && status === false) {
            return {
                section: (t("Instagram page")),
                title : (t("Instagram page not set successfully")),
                text : (t("I changed my mind")),
                main: (t("Integrate Instagram Page")), 
                red : (t("Do not integrate Instagram page")),
                img :"https://genius1071.friktoriaservers.net/doitforme/morning/app/global/Fail.svg"
            };
        }     
        else if(!flow[index] && status === true) {
            return {
                section: (t("Instagram page")),
                title : (t("Instagram page set successfully")),
                text : instaPage,
                main: (t("Go to report")), 
                red: "",
                img :"https://genius1071.friktoriaservers.net/doitforme/morning/app/global/Success.svg"
            };
        }      
        else if(!flow[index] && status === false) {
            return {
                section: (t("Instagram page")),
                title : (t("Instagram page not set successfully")),
                text : (t("I changed my mind")),
                main: (t("Go to report")), 
                red: "",
                img :"https://genius1071.friktoriaservers.net/doitforme/morning/app/global/Fail.svg"
            };
        }         
             
    }
}
